module.exports = __webpack_public_path__ + "static/img/jiuSign.267b455.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jiuSign.png
// module id = ZYcm
// module chunks = 1